import { render, staticRenderFns } from "./ButtonValidate.vue?vue&type=template&id=0353a316&scoped=true&"
import script from "./ButtonValidate.vue?vue&type=script&lang=js&"
export * from "./ButtonValidate.vue?vue&type=script&lang=js&"
import style0 from "./ButtonValidate.vue?vue&type=style&index=0&id=0353a316&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0353a316",
  null
  
)

export default component.exports